import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCouponCode } from "../../redux/slice/couponSlice";
import { useNavigate } from "react-router-dom";

const CouponTimer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { couponCode, expiryTime, discount } = useSelector((state) => state.coupon);

    const [timeLeft, setTimeLeft] = useState(expiryTime - Date.now());

    useEffect(() => {
        if (!expiryTime) return;

        const intervalId = setInterval(() => {
            const timeRemaining = expiryTime - Date.now();
            if (timeRemaining <= 0) {
                clearInterval(intervalId);
                dispatch(clearCouponCode());
            } else {
                setTimeLeft(timeRemaining);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [expiryTime, dispatch]);

    if (!couponCode) return null;

    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    return (
        <div className="w-full text-white font-medium text-lg">
            <div className="mx-auto w-[70%] bg-[#0E0E0E] py-2 px-5 shadow-md shadow-[#FFDD15] min-h-[80px] text-center">
                <div className="text-white font-bold text-xl">CONGRATULATIONS!</div>
                <div className="text-[#FFDD15] font-bold text-xl">YOU WON {discount} COUPON CODE</div>
            </div>
            <div className="text-center mt-4">
                Your Coupon Code: {couponCode}
            </div>
            <div className="flex flex-col items-center justify-center text-center mt-4">
                <p>Expiration time:</p>
                <p>{hours}h {minutes}m {seconds}s</p>
            </div>
            <div className="flex items-center justify-center mt-4">
                <button
                    className='bg-[#FFDD15] text-[#0E0E0E] flex justify-center items-center gap-2 px-5 font-semibold py-2 rounded-md text-center w-auto'
                    onClick={() => navigate('/deposit')}
                >Deposit Now
                </button>
            </div>
        </div>
    );
};

export default CouponTimer;
